import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ children, render, theme }) =>
  render ? <div className={theme.overlayContainer}>{children}</div> : null;

export default Overlay;

Overlay.propTypes = {
  children: PropTypes.node,
  render: PropTypes.bool,
  theme: PropTypes.shape({}),
};
